import { Box, ListItemButton, Paper, Skeleton, Tooltip, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AppState } from "../../../../../../../../shell/store/types";
import { useGetUsersQuery } from "../../../../../../../../shell/services/accounts";
import blockPlaceholder from "../../../../../../../../../public/images/blockPlaceholder.png";
import { ContentItem } from "../../../../../../../../shell/services/types";
import { formatLocalized } from "shell/i18n/dates";
import { isValid } from "date-fns";
export const BlockVariantCard = ({
  block
}: {
  block: ContentItem;
}) => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    modelZUID,
    itemZUID
  } = useParams<{
    modelZUID: string;
    itemZUID: string;
  }>();
  const isCapturingScreenshot = useSelector((state: AppState) => state.content?.[block.meta.ZUID]?.capturingScreenshot) || false;
  const {
    data: users
  } = useGetUsersQuery();
  const updatedByUser = users?.find(user => user.ZUID === block.web?.createdByUserZUID);
  return <Tooltip enterDelay={500} enterNextDelay={500} disableInteractive placement="left" title={<Paper elevation={8}>
          {isCapturingScreenshot ? <Skeleton variant="rectangular" width={400} height={300} /> : <Box component="img" width={400} height={300} src={block.data?.og_image as string || blockPlaceholder} loading="lazy" sx={{
      objectFit: "contain"
    }}></Box>}
        </Paper>} components={{
    Tooltip: Box
  }} slotProps={{
    popper: {
      sx: {
        maxWidth: "none"
      }
    }
  }} data-sentry-element="Tooltip" data-sentry-component="BlockVariantCard" data-sentry-source-file="BlockVariantCard.tsx">
      <ListItemButton divider selected={itemZUID === block.meta.ZUID || Object?.values(block?.siblings || {})?.includes(itemZUID)} disableGutters sx={{
      position: "relative",
      overflow: "hidden",
      px: 2,
      py: 1.75,
      gap: "0px 12px",
      "&.Mui-selected": {
        "&:first-of-type": {
          borderBottomColor: "primary.main"
        },
        "&:not(:last-of-type)": {
          borderBottomColor: "primary.main"
        }
      }
    }} onClick={() => history.push(`/blocks/${modelZUID}/${block.meta.ZUID}`)} data-sentry-element="ListItemButton" data-sentry-source-file="BlockVariantCard.tsx">
        <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        overflow: "hidden"
      }} data-sentry-element="Box" data-sentry-source-file="BlockVariantCard.tsx">
          <Typography variant="body1" fontWeight={700} sx={{
          wordBreak: "break-word",
          minHeight: "24px"
        }} data-sentry-element="Typography" data-sentry-source-file="BlockVariantCard.tsx">
            {block?.web?.metaTitle ?? ""}
          </Typography>
          <Typography variant="body3" color="text.secondary" mt={0.5} fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="BlockVariantCard.tsx">
            {t("content.blockUpdatedOnBy", {
            date: isValid(new Date(block.web?.updatedAt)) ? formatLocalized(new Date(block.web?.updatedAt), "MMM d, yyyy") : "",
            updatedBy: [updatedByUser?.firstName, updatedByUser?.lastName].filter(Boolean).join(" ")
          })}
          </Typography>
        </Box>
      </ListItemButton>
    </Tooltip>;
};